export default {
    pageName: 'Approval Inquiry',
    search: {
        title: '',
        placeholder: '- Leave Type -'
    },
    header: {
        full: 'Detail',
        sub: 'Inquiry Date'
    },
    button: {
        approve: 'Approve',
        reject: 'Reject'
    },
    modalSuccess: {
        title: 'Success',
        body: 'Inquiry Status saved',
        btnOk: 'CONFIRM'
    },
    modalFail: {
        title: 'Sorry, unable to process',
        body: '',
        btnOk: 'CLOSE'
    }
}
